// extracted by mini-css-extract-plugin
export var container = "_6s-0";
export var infoButton = "_6s-1";
export var label = "_6s-3";
export var labelExpanded = "_6s-4";
export var price = "_6s-5";
export var priceExpanded = "_6s-6";
export var title = "_6s-2";